import {OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {LoggerService} from '../';

/**
 * adds ngOnDestroy$
 */
export abstract class CommonComponent implements OnInit, OnDestroy {

    protected ngOnDestroy$: Subject<any> = new Subject();
    protected subQueryParams: any = null;
    protected appStateSubscription: any = null;
    protected eventServiceSubscription: any = null;

    constructor(protected logger: LoggerService) {
        // this.logger.log('CommonComponent: constructor:');
    }

    ngOnInit(): void {
        // this.logger.log('CommonComponent: ngOnInit:');
    }

    protected attachSubQueryParams(subQueryParams: any) {
        if (this.subQueryParams) {
            this.subQueryParams.unsubscribe();
        }
        this.subQueryParams = subQueryParams;
    }

    protected attachAppStateSubscription(appStateSubscription: any) {
        if (this.appStateSubscription) {
            this.appStateSubscription.unsubscribe();
        }
        this.appStateSubscription = appStateSubscription;
    }

    protected attachEventServiceSubscription(eventServiceSubscription: any) {
        if (this.eventServiceSubscription) {
            this.eventServiceSubscription.unsubscribe();
        }
        this.eventServiceSubscription = eventServiceSubscription;
    }

    ngOnDestroy(): void {

        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();

        // this.logger.log('CommonComponent: ngOnDestroy:');

        this.attachSubQueryParams(null);
        this.attachAppStateSubscription(null);
        this.attachEventServiceSubscription(null);

    }

}
